var _path, _path2, _path3, _rect, _path4, _rect2, _path5, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRadioGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 121,
  height: 72,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-surface-selected)",
  d: "M1.078 8a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--hop-neutral-border-selected)",
  d: "M1.078 8a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-icon-selected)",
  fillRule: "evenodd",
  d: "M12.853 4.646a.58.58 0 0 1 .022.82L7.66 10.97a.58.58 0 0 1-.83.012l-2.9-2.897a.58.58 0 1 1 .82-.82l2.476 2.477 4.807-5.074a.58.58 0 0 1 .819-.022Z",
  clipRule: "evenodd"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 88,
  height: 4,
  x: 32.578,
  y: 6,
  fill: "var(--hop-neutral-border-weak)",
  rx: 2
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--hop-neutral-border-selected)",
  strokeWidth: 2,
  d: "M1.578 36a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 88,
  height: 4,
  x: 32.578,
  y: 34,
  fill: "var(--hop-neutral-border-weak)",
  rx: 2
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--hop-neutral-border-selected)",
  strokeWidth: 2,
  d: "M1.578 64a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 88,
  height: 4,
  x: 32.578,
  y: 62,
  fill: "var(--hop-neutral-border-weak)",
  rx: 2
})));
export default SvgRadioGroup;